module.exports = __webpack_public_path__ + "static/media/NewAddAdmin.62489b0a.svg";